var React = require('react');

function Confirmation (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"40","height":"40","rx":"20","fill":"#2C6774","key":0}),React.createElement("path",{"d":"M12.0607 18.4393C11.4749 17.8536 10.5251 17.8536 9.93934 18.4393C9.35355 19.0251 9.35355 19.9749 9.93934 20.5607L12.0607 18.4393ZM18.5 27L17.4393 28.0607C17.7479 28.3692 18.1756 28.5281 18.6108 28.4959C19.046 28.4637 19.4456 28.2435 19.7053 27.8928L18.5 27ZM29.7053 14.3928C30.1984 13.7272 30.0585 12.7878 29.3928 12.2947C28.7272 11.8016 27.7878 11.9415 27.2947 12.6072L29.7053 14.3928ZM9.93934 20.5607L17.4393 28.0607L19.5607 25.9393L12.0607 18.4393L9.93934 20.5607ZM19.7053 27.8928L29.7053 14.3928L27.2947 12.6072L17.2947 26.1072L19.7053 27.8928Z","fill":"#F4FCFA","key":1})]);
}

Confirmation.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Confirmation;

Confirmation.default = Confirmation;
